import * as React from 'react';
import PropTypes from 'prop-types';
import ChannelItem from './channelListItem';
import { MuiThemeProvider } from '@material-ui/core/styles';
// import { themeDark as theme } from '../../../../Util/widthRoot';
import { themeDark as theme } from '../../../../Util/widthRoot';

const propTypes = {
  group_id: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  select: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onClick: PropTypes.func,
  onClickEPG: PropTypes.func,
};

const defaultProps = {
  group_id: '',
  list: [],
  select: {
    _id: null,
  },
  onClick: null,
  onClickEPG: null,
};


const ChannelList = props => {
  // onClick: player.jsx << handlerChannelSelect, onClickEPG: player.jsx << handlerEPGSelect
  const { group_id, list, select, onClick, onClickEPG } = props;
  return (
    <div className="channel-list-container">
      <div className="channel-list-scroll">
        <div className="channel-list-body">
          <MuiThemeProvider theme={theme}>
            {list.map(chItem => {
              let isSelect = false;
              if (select && chItem._id === select._id) {
                isSelect = true;
              }
              return (
                <ChannelItem
                  key={chItem._id}
                  select={isSelect}
                  group={group_id}
                  {...chItem}
                  onClick={onClick}
                  onClickEPG={onClickEPG}
                >
                  {chItem.title}
                </ChannelItem>
              );
            })}
          </MuiThemeProvider>
        </div>
      </div>
    </div>
  );
};

ChannelList.propTypes = propTypes;
ChannelList.defaultProps = defaultProps;

export default ChannelList;
